import { defineMessages } from 'react-intl';

const messages = defineMessages({
  assetsClearSearchButtonLabel: {
    id: 'assetsClearSearchButtonLabel',
    defaultMessage: 'Clear search',
    description: 'Label for a button that clears the search applied to a table.',
  },
});

export default messages;
